export default __webpack_public_path__ + "static/media/mody.840d8630.png";